import axios from 'axios'
const WP_HOME = `https://members.eccourts.org`
import authService from './authService'
export default {
  get(id) {
    return axios.get(`${WP_HOME}/wp-json/wp/v2/tickets/?author=${id}`);
  },
  getComments(pid) {
    let token = authService.getCookie('wcmCookie')
    return axios.get(`${WP_HOME}/wp-json/wp/v2/comments/?post=${pid}&context=edit`,
    {
      headers: { "Authorization": 'Bearer ' + token }
    })
  },
  deleteComment(id) {
    let token = authService.getCookie('wcmCookie')
    return axios.delete(`${WP_HOME}/wp-json/wp/v2/comments/${id}?force=true`,
    {
      headers: { "Authorization": 'Bearer ' + token }
    })
  },
  submitComment(comment, token) {
    return axios.post(`${WP_HOME}/wp-json/wp/v2/comments`,comment,{
      headers: { "Authorization": 'Bearer ' + token }
    })
  },
  createTicket(post,token){
    return axios.post(`${WP_HOME}/wp-json/wp/v2/tickets`,post,{
      headers: { "Authorization": 'Bearer ' + token }
    })
  },
  updateTicket(data, token, id){
    return axios.post(`${WP_HOME}/wp-json/wp/v2/tickets/${id}`,data,
    {   
    headers:{
    "Authorization": 'Bearer'+token 
      }
    })
  }
  
};
